// store.js
import { reactive } from 'vue'

export const mobileOverlayStore = reactive({
  showOverlay: false
})
